// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "main[\\:has\\(\\%23error-container\\)]{background-color:#000!important}main:has(#error-container){background-color:#000!important}", ""]);
// Exports
module.exports = exports;
